import { servicosSaudePrecosApi } from "@/api/ServicosSaudePrecosApi";
import PrecificacaoFiltro from "@/models/cadastros/saude/PrecificacaoFiltro";
import PrecificacaoModel from "@/models/cadastros/saude/PrecificacaoModel";
import { PaginationModel } from "@/models/commons/PaginationModel";

class SaudePrecificacaoService {
  pesquisar(filtro?: PrecificacaoFiltro, options?: PaginationModel) {
    const filtroDTO = {
      idCidade: filtro?.cidade?.id,
      idEspecialidade: filtro?.especialidade?.id,
      estado: filtro?.estado?.sigla,
      size: options?.itemsPerPage,
      page: options?.page ? options?.page - 1 : 0,
    };

    return servicosSaudePrecosApi.pesquisarPrecos(filtroDTO);
  }

  salvar(preco?: PrecificacaoModel) {
    const precoDTO = {
      idCidade: preco?.cidade?.id,
      especialidade: {
        id: preco?.especialidade?.id,
        nome: preco?.especialidade?.nome,
      },
      // precoAssociado: Number(
      //   preco?.precoAssociado
      //     ? preco.precoAssociado
      //         .toString()
      //         .replace(/\./g, "")
      //         .replace(/,/g, ".")
      //     : "0.00"
      // ),
      precoAssociado: Number(
        preco?.precoAssociado
          ? preco.precoAssociado
          : "0.00"
      ),
    };

    return servicosSaudePrecosApi.salvarPreco(precoDTO);
  }

  deletar(idPreco: Number) {
    return servicosSaudePrecosApi.deletarPreco(idPreco);
  }

  obterPrecoPorId(idPreco: Number) {
    return servicosSaudePrecosApi.obterPrecoPorId(idPreco);
  }

  atualizar(preco: PrecificacaoModel, idPreco: Number) {
    const precoDTO = {
      id: preco.id,
      idCidade: preco.cidade?.id,
      especialidade: preco.especialidade,
      // precoAssociado: Number(
      //   preco.precoAssociado
      //     ? preco.precoAssociado
      //         .toString()
      //         .replace(/\./g, "")
      //         .replace(/,/g, ".")
      //     : "0.00"
      // ),
      precoAssociado: Number(
        preco.precoAssociado
          ? preco.precoAssociado
          : "0.00"
      ),
    };

    return servicosSaudePrecosApi.atualizarPreco(idPreco, precoDTO);
  }
}

export const saudePrecificacaoService = new SaudePrecificacaoService();
